const modal_confirm_change_tab = {
  title: 'Vous avez des modifications non enregistrées',
  subtitle:
    'En confirmant, vous perdrez toutes les modifications non enregistrées',
  cancel: 'Annuler',
  confirm: 'Confirmer',
}

export default modal_confirm_change_tab
